export const TOAST_MESSAGE = {
  ADMIN: {
    LOGIN: {
      FAILED: '관리자 로그인이 실패했습니다.',
    },

    LOGOUT: {
      SUCCESS: '로그아웃 되었습니다.',
      FAILED: '로그아웃이 실패했습니다.',
    },

    ACCOUNT_INFO: {
      INFO_INQUIRY: {
        UPDATE: {
          SUCCESS: '수정 되었습니다.',
          FAILED: '수정이 실패했습니다.',
        },
      },
      CHANGE_PASSWORD: {
        CURRENT_PASSWORD: {
          FAILED: '현재 비밀번호가 아닙니다. 다시 입력해 주세요.',
        },
        NEW_PASSWORD: {
          SUCCESS: '수정 되었습니다. ',
          FAILED: '수정이 실패했습니다.',
        },
      },
    },

    SYSTEM: {
      PREFERENCES: {
        SUBMIT: {
          UPDATE: {
            SUCCESS: '환경설정 데이터 전송되었습니다.',
            FAILED: '환경설정 데이터 전송이 실패했습니다.',
          },
        },
      },
    },
  },

  CUSTOMER_DELIVERY: {},
};
